import { mypage } from './mypage';
import { inputConfig } from "./config";

import "./index";

window.addEventListener("load", function () {
  mypage();
});

let valueLookup = {
  short: "Kort hår",
  long: "Langt hår",
  asap: "ASAP, det haster!",
  week: "I løpet av de neste 5 dagene",
  cut: "Kun klipp",
  "color-stripes": "Farge eller striper",
  "bergen-sentrum": "Bergen sentrum",
  "bergen-sor": "Bergen sør",
  "bergen-aasane": "Åsane",
  "bergen-vest": "Bergen vest",
  "specific-time": "Kundens egen forklaring",
};
// add new option to valueLookup
for (c in inputConfig) {
  for (v in inputConfig[c].data) {
    valueLookup[inputConfig[c].data[v].value] = inputConfig[c].data[v].label;
  }
}

window.translateKeys = function(key) {
  if (typeof valueLookup[key] != "undefined") {
    return valueLookup[key];
  } else {
    return key;
  }
};

